import { render, staticRenderFns } from "./veelgestelde-vragen.vue?vue&type=template&id=607ac86c"
import script from "./veelgestelde-vragen.vue?vue&type=script&lang=js"
export * from "./veelgestelde-vragen.vue?vue&type=script&lang=js"
import style0 from "./veelgestelde-vragen.vue?vue&type=style&index=0&id=607ac86c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports